import React, { useEffect, useState } from 'react';
import './index.css';
import { variables } from '../Variables/Variable';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom';

const Careers = () => {
    const [fName, setFName] = useState("");
    const [mName, setMName] = useState("");
    const [lName, setLName] = useState("");
    const [phone, setPhone] = useState("");
    const [email, setEmail] = useState("");
    const [date, setDate] = useState("");
    const [address, setAddress] = useState("");
    const [school, setSchool] = useState("");
    const [education, setEducation] = useState("");
    const [dateGraducation, setDateGraducation] = useState("");
    const [school1, setSchool1] = useState("");
    const [education1, setEducation1] = useState("");
    const [dateGraducation1, setDateGraducation1] = useState("");
    const [training, setTraining] = useState("");
    const [company, setCompany] = useState("");
    const [startDate, setStartDate] = useState("");
    const [job, setJob] = useState("");
    const [company2, setCompany2] = useState("");
    const [startDate2, setStartDate2] = useState("");
    const [job2, setJob2] = useState("");
    const [company3, setCompany3] = useState("");
    const [startDate3, setStartDate3] = useState("");
    const [job3, setJob3] = useState("");
    const [info, setInfo] = useState("");
    const [skills, setSkills] = useState("");
    const [chkArabic, setChkArabic] = useState("Arabic");
    const [chkEnglish, setChkEnglish] = useState("English");
    const [chkFrench, setChkFrench] = useState("French");
    const [chkOther, setChkOther] = useState("Other");
    const [other, setOther] = useState("");
    const [errors, setErrors] = useState({});
    const [languages, setLanguages] = useState([]);
    const ID = useParams();
    const [menu,setMenu] = useState([]);

    function handleValidation() {
        let errors = {};
        let formIsValid = true;

        //First Name
        if (fName == "") {
            formIsValid = false;
            errors["fName"] = "Cannot be empty";
        }

        if (typeof fName !== "undefined") {
            if (!fName.match(/^[a-zA-Z]+$/)) {
                formIsValid = false;
                errors["fname"] = "Only letters";
            }
        }
        // Middle Name
        if (mName == "") {
            formIsValid = false;
            errors["mName"] = "Cannot be empty";
        }

        if (typeof mName !== "undefined") {
            if (!mName.match(/^[a-zA-Z]+$/)) {
                formIsValid = false;
                errors["mName"] = "Only letters";
            }
        }
        // Last Name
        if (lName == "") {
            formIsValid = false;
            errors["lName"] = "Cannot be empty";
        }

        if (typeof lName !== "undefined") {
            if (!lName.match(/^[a-zA-Z]+$/)) {
                formIsValid = false;
                errors["lName"] = "Only letters";
            }
        }

        //Email
        if (email == "") {
            formIsValid = false;
            errors["email"] = "Cannot be empty";
        }
        if (typeof email !== "undefined") {
            let lastAtPos = email.lastIndexOf("@");
            let lastDotPos = email.lastIndexOf(".");

            if (
                !(
                    lastAtPos < lastDotPos &&
                    lastAtPos > 0 &&
                    email.indexOf("@@") == -1 &&
                    lastDotPos > 2 &&
                    email.length - lastDotPos > 2
                )
            ) {
                formIsValid = false;
                errors["email"] = "Email is not valid";
            }
        }

        // if (/^[a-zA-Z0-9]+@[a-zA-Z0-9]+\.[A-Za-z]+$/.test(email)) {
        //     formIsValid = false;
        //     errors["email"] = "Invalid email format";
        // }
        // Phone NUmber
        if (phone == "") {
            formIsValid = false;
            errors["phone"] = "Cannot be empty";
        }

        if (typeof phone !== "undefined") {
            if (!phone.match(/^[0-9\b]+$/)) {
                formIsValid = false;
                errors["phone"] = "Only Numbers";
            }
        }
        // address
        if (address == "") {
            formIsValid = false;
            errors["address"] = "Cannot be empty";
        }

        // // date validation
        // var dateReg = /^\d{2}([./-])\d{2}\1\d{4}$/
        // if (date == "") {
        //     formIsValid = false;
        //     errors["date"] = "Cannot be empty";
        // }
        // if (!date.match(dateReg)) {
        //     formIsValid = false;
        //     errors["date"] = "Please provide correct date Format dd-mm-yyyy";
        // }
        setErrors(errors);
        return formIsValid;
    }

    const HandleCheckBox = (e) => {
        var languagesArray = [...languages];

        if (e.target.name == "language") {
            if (e.target.checked) {
                languagesArray.push(e.target.value);
                languages.push(e.target.value);
            } else {
                var index = languagesArray.indexOf(e.target.value);
                if (index !== -1) {
                    languagesArray.splice(index, 1);
                    languages.splice(index, 1);
                }
            }
        }

    }
    const getMenuDetails = () => {
        fetch(variables.API_URL + "Menu/GetMenuDetails/" + 31, {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        })
            .then((Response) => {
                if (Response.ok) {
                    return Response.json();
                }
            })
            .then((Result) => {
                setMenu(Result)
            });
    };


    const handleSubmit = (e) => {
        e.preventDefault();
        if (handleValidation()) {
            fetch(variables.API_URL + "Contact/SendCareerEmail/", {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    "Access-Control-Allow-Origin": variables.API_URL,
                },
                body: JSON.stringify({
                    FirstName: fName,
                    MiddleName: mName,
                    LastName: lName,
                    Email: email,
                    PhoneNumber: phone,
                    DOB: date,
                    Address: address,
                    School: school,
                    Education: education,
                    DateGraduation: dateGraducation,
                    School1: school1,
                    Education1: education1,
                    DateGraduation1: dateGraducation1,
                    Training: training,
                    Company: company,
                    StartDate: startDate,
                    Job: job,
                    Company2: company2,
                    StartDate2: startDate2,
                    Job2: job2,
                    Company3: company3,
                    StartDate3: startDate3,
                    Job3: job3,
                    AdditionalInformation: info,
                    ComputerSkills: skills,
                    Languages: languages,
                    OtherLanguages: other

                }),
            })
                .then((Response) => {
                    if (Response.ok) {
                        toast.success("Email sent Sucessfully");
                        setDateGraducation1("");
                        setEducation("");
                        setEducation1("");
                        setSchool("");
                        setSchool1("");
                        fName("");
                        setMName("");
                        setLName("");
                        setEmail("");
                        setPhone("");
                        setAddress("");
                        setDate("");
                        setOther("");
                        setLanguages("");
                        setSkills("");
                        setInfo("");
                        setJob("");
                        setJob2("");
                        setJob3("");
                        setTraining("");
                        setDateGraducation("");
                        setStartDate("");
                        setStartDate2("");
                        setStartDate3("");
                        setCompany("");
                        setCompany2("");
                        setCompany3("");
                        return Response.json();
                    }
                })
        }
    }

    useEffect(() => {
        getMenuDetails();
    })





    return (
        <>
            {/* <!--Start Page Header--> */}
            <section className="page-header">
                <div className="page-header__bg" style={{ backgroundImage: `url(${variables.PHOTO_URL + menu.ImageUrl})` }}>
                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="page-header__wrapper">
                                <div className="page-header__content">
                                    <h2>{ID.MenuTitle}</h2>
                                    <div className="page-header__menu">
                                        <ul>
                                            <li><a hreflang="en" href="/">Home</a></li>
                                            <li>{ID.MenuTitle}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <!--End Page Header--> */}
            <section className='page_single'>
                <div className='container'>
                    <div class="row contact-bottom padTB100">
                        <div className='col-md-12'>
                            <div className="text-center centered-title">
                                <div className='topborder'></div>
                                <h2>Home Depot Careers</h2>
                                <div className='topborder'></div>
                                <div className="clear"></div>
                                <p>To Apply for a job at Home Depot of Lebanon, please fill in the form below.
                                    <br />
                                    Fields marked with an asterisk (*) are required.</p>
                                <div className="clear"></div>
                            </div>
                        </div>
                        <div class="col-md-12 left-box">
                            <form onSubmit={handleSubmit} id="fashion_contactform">
                                <label className='pt-4'><strong>Personal Information</strong></label>
                                <div class="row">
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label>First Name *</label>
                                            <input className='form-control' id='txtFName' type="text" placeholder="First Name" value={fName} name="FName" onChange={(e) => setFName(e.target.value)} />
                                            <span style={{ color: "red" }}>{errors["fName"]}</span>
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label>Middle Name *</label>
                                            <input className='form-control' id='txtMName' type="text" placeholder="Middle Name" value={mName} name="MName" onChange={(e) => setMName(e.target.value)} />
                                            <span style={{ color: "red" }}>{errors["mName"]}</span>
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label>Last Name *</label>
                                            <input className='form-control' id='txtLName' type="text" placeholder="Last Name" value={lName} name="LName" onChange={(e) => setLName(e.target.value)} />
                                            <span style={{ color: "red" }}>{errors["lName"]}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label>Email *</label>
                                            <input className='form-control' id='txtEmail' type="email" placeholder="Email" value={email} name="Email" onChange={(e) => setEmail(e.target.value)} />
                                            <span style={{ color: "red" }}>{errors["email"]}</span>
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label>Phone Number *</label>
                                            <input className='form-control' type="text" placeholder="Phone" value={phone} name="Phone" onChange={(e) => setPhone(e.target.value)} />
                                            <span style={{ color: "red" }}>{errors["phone"]}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label>Date Of Birth *</label>
                                            <input id='txtDOB' className='form-control' type="date" placeholder="Date of Birth" value={date} name="Date" onChange={(e) => setDate(e.target.value)} />
                                            <span style={{ color: "red" }}>{errors["date"]}</span>
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label>Address *</label>
                                            <input id='txtAddress' className='form-control' type="text" placeholder="Address" value={address} name="Address" onChange={(e) => setAddress(e.target.value)} />
                                            <span style={{ color: "red" }}>{errors["address"]}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="clear"></div>
                                <label className='pt-4'><strong>Education</strong></label>
                                <div class="row">
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label>School/University Name</label>
                                            <input id='txtSchool' className='form-control' type="text" placeholder="School/University Name" value={school} name="School" onChange={(e) => setSchool(e.target.value)} />
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label>Education Field</label>
                                            <input id='txtEducationField' className='form-control' type="text" placeholder="Education Field" value={education} name="Education" onChange={(e) => setEducation(e.target.value)} />
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label>Year Of Graduation</label>
                                            <input id='txtDateGraduation' className='form-control' type="date" placeholder="Year Of Graduation" value={dateGraducation} name="Year Of Graduation" onChange={(e) => setDateGraducation(e.target.value)} />
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label>School/University Name</label>
                                            <input id='txtSchool1' className='form-control' type="text" placeholder="School/University Name" value={school1} name="School1" onChange={(e) => setSchool1(e.target.value)} />
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label>Education Field</label>
                                            <input id='txtEducationField1' className='form-control' type="text" placeholder="Education Field" value={education1} name="Education1" onChange={(e) => setEducation1(e.target.value)} />
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label>Year Of Graduation</label>
                                            <input id='txtDateGraduation1' className='form-control' type="date" placeholder="Year Of Graduation" value={dateGraducation1} name="Year Of Graduation1" onChange={(e) => setDateGraducation1(e.target.value)} />
                                        </div>
                                    </div>
                                </div>
                                <div class="clear"></div>
                                <label className='pt-4'><strong>Training and Professional Experience</strong></label>
                                <div class="row">
                                    <div class="col-sm-12">
                                        <div class="form-group">
                                            <label>Training</label>
                                            <textarea id="txtTraining" className='form-control' placeholder="Describe in a few lines what you did in your Training" name="Training" value={training} onChange={(e) => setTraining(e.target.value)}></textarea>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label>Company Name</label>
                                            <input id='txtCompany' className='form-control' type="text" placeholder="Company Name" value={company} name="Company" onChange={(e) => setCompany(e.target.value)} />
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label>Start/End Date</label>
                                            <input id='txtDate' className='form-control' type="date" placeholder="Start/End Date" value={startDate} name="StartEndDate" onChange={(e) => setStartDate(e.target.value)} />
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label>Job Title</label>
                                            <input id='txtJob' className='form-control' type="text" placeholder="Job Title" value={job} name="Training" onChange={(e) => setJob(e.target.value)} />
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label>Company Name</label>
                                            <input id='txtCompany2' className='form-control' type="text" placeholder="Company Name" value={company2} name="company2" onChange={(e) => setCompany2(e.target.value)} />
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label>Start/End Date</label>
                                            <input id='txtDate2' className='form-control' type="date" placeholder="Start/End Date" value={startDate2} name="StartDate2" onChange={(e) => setStartDate2(e.target.value)} />
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label>Job Title</label>
                                            <input id='txtJob2' className='form-control' type="text" placeholder="Job Title" value={job2} name="Training2" onChange={(e) => setJob2(e.target.value)} />
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label>Company Name</label>
                                            <input id='txtCompany3' className='form-control' type="text" placeholder="Company Name" value={company3} name="company3" onChange={(e) => setCompany3(e.target.value)} />
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label>Start/End Date</label>
                                            <input id='txtDate3' className='form-control' type="date" placeholder="Start/End Date" value={startDate3} name="StartDate3" onChange={(e) => setStartDate3(e.target.value)} />
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label>Job Title</label>
                                            <input id='txtJob3' className='form-control' type="text" placeholder="Job Title" value={job3} name="Training3" onChange={(e) => setJob3(e.target.value)} />
                                        </div>
                                    </div>
                                </div>
                                <div class="clear"></div>
                                <label className='pt-4'><strong>Additional Information</strong></label>
                                <br />
                                <label>References</label>
                                <div className='row'>
                                    <div class="col-sm-12">
                                        <div class="form-group">
                                            <label>Additional Information</label>
                                            <textarea id="txtInfo" className='form-control' placeholder="Additional Info" name="Info" value={info} onChange={(e) => setInfo(e.target.value)}></textarea>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label>Computer Skills</label>
                                            <textarea name="txtSkills" className='form-control' placeholder="Your Message here" value={skills} onChange={(e) => setSkills(e.target.value)}></textarea>
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label>Languages</label>
                                            <br />
                                            <div class="col-sm-6">
                                                <div class="col-sm-6">
                                                    <input
                                                        id='chkArabic'
                                                        Text="Arabic"
                                                        type="checkbox"
                                                        name="language"
                                                        value="Arabic"
                                                        onClick={HandleCheckBox}
                                                    />
                                                    <label for="element" style={{ fontSize: 20 }}>
                                                        {chkArabic}
                                                    </label>
                                                </div>
                                                <div class="col-sm-6">
                                                    <input
                                                        id='chkEnglish'
                                                        Text="English"
                                                        type="checkbox"
                                                        name="language"
                                                        value="English"
                                                        onClick={HandleCheckBox}
                                                    />
                                                    <label for="element" style={{ fontSize: 20 }}>
                                                        {chkEnglish}
                                                    </label>
                                                </div>
                                                <div class="col-sm-6">
                                                    <input
                                                        id='chkFrench'
                                                        Text="French"
                                                        type="checkbox"
                                                        name="language"
                                                        value="French"
                                                        onClick={HandleCheckBox}
                                                    />
                                                    <label for="element" style={{ fontSize: 20 }}>
                                                        {chkFrench}
                                                    </label>
                                                </div>
                                                <div class="col-sm-6">
                                                    <input
                                                        id='chkOther'
                                                        Text="Other"
                                                        type="checkbox"
                                                        name={chkOther}
                                                        value={chkOther}
                                                        onChange={(e) => setChkOther(e.target.value)}
                                                    />
                                                    <label for="element" style={{ fontSize: 20 }}>
                                                        {chkOther}
                                                    </label>
                                                </div>
                                            </div>
                                            <div class="col-sm-6">
                                                <textarea name="txtOther" className='form-control' placeholder="Other languages" value={other} onChange={(e) => setOther(e.target.value)}></textarea>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-sm-12'>
                                        <button dis type="submit" className="thm-btn comment-form__btn">
                                            Send
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}
export default Careers;